import { Link } from 'gatsby';
import styled from 'styled-components';
import { fontSize, padding, textColors } from '../../assets/styles/props';
import { COLORS } from '../../assets/styles/constants';

export const YambMainLink = styled(Link)`
	${fontSize};
	${padding};
	color: ${COLORS.MAIN_PURPLE};
	${textColors};
	
	&:hover {
		background-image: linear-gradient(180deg,#353944 80%,#353944 0);
	    background-repeat: repeat-x;
	    background-size: 1px 1px;
	    background-position: 0 98%;
	}
`;

YambMainLink.defaultProps = {
	fontSize: 'h3',
};
